import { EnvironmentsAPI } from "../../providers/EnvironmentsAPI";
import { Storage } from "./Storage";

export class EnvironmentStorage extends Storage {

    static getEnvironment()     {
        return EnvironmentStorage.getItem('environment');
    }

    static setUsers(user){
        return EnvironmentStorage.setItem('user', user);
    }

    static setEnvironment(environmentBody) {
        return EnvironmentStorage.setItem('environment', environmentBody);
    }
    
    static getSelectedEnvironment() {
        return EnvironmentStorage.getItem('selectedEnvironment');
    }

    static setSelectedEnvironment(environmentId) {
        return EnvironmentStorage.setItem('selectedEnvironment', environmentId);
    }
    
    static getConfigurations() {
        return EnvironmentStorage.getItem('environmentConfigurations');
    }

    static setConfigurations(configurations) {
        return EnvironmentStorage.setItem('environmentConfigurations', configurations);
    }

    static getFreeDelivery() {
        return EnvironmentStorage.getItem('freeDelivery');
    }

    static setFreeDelivery(freeDelivery) {
        return EnvironmentStorage.setItem('freeDelivery', freeDelivery);
    }

    static getCurrentAvatar() {
        const environment = EnvironmentStorage.getEnvironment();
        if(environment?.type === "BRAND" && environment?.avatarUrl) {
            return process.env.REACT_APP_ASSETS_URL + `/` + environment.avatarUrl;
        } else if(environment?.brand?.avatarUrl) {
            return process.env.REACT_APP_ASSETS_URL + `/` + environment.brand.avatarUrl;
        }
        
        return null;
    }

    static async getEnvironmentHoldingId() {
        let holdingId = null;

        const environment = EnvironmentStorage.getEnvironment();
        if (!environment?.holdingId) {
            const environmentConfigurations = EnvironmentStorage.getConfigurations();
            if (environmentConfigurations?.type === 'BRAND')
                holdingId = environmentConfigurations.environment_id;

            const environmentReq = await EnvironmentsAPI.getById(
                environment?.id
            );
            const environmentData = environmentReq.getData({});
            holdingId = environmentData.holdingId || null;
        } else {
            holdingId = environment.holdingId;
        }

        if (holdingId) {
            EnvironmentStorage.setEnvironment({
                ...EnvironmentStorage.getEnvironment(),
                holdingId,
            });
        }

        return holdingId;
    }

    static getEnvironmentBrandId() {
        const environment = EnvironmentStorage.getEnvironment();
        
        let brandId = environment?.brand?.id;
        if (!brandId) {
            const selectedEnvironment = EnvironmentStorage.getConfigurations();
            
            brandId = selectedEnvironment.type === 'BRAND'
                ? selectedEnvironment.id
                : selectedEnvironment.environment_id;
        }

        return brandId;
    }

    static async getEnvironmentExtraMenus() {
        let extra_menus = null;

        const environmentConfigurations = EnvironmentStorage.getConfigurations();

        if(!environmentConfigurations) return null;

        if (!environmentConfigurations.extra_menus) {
            if (environmentConfigurations?.type === 'BRAND') {
                const environmentExtraMenus = await EnvironmentsAPI.getConfigurationsByAlias(
                    environmentConfigurations.id,
                    'extra_menus'
                );
                extra_menus = environmentExtraMenus || null;
            } else {
                const brandExtraMenus = await EnvironmentsAPI.getConfigurationsByAlias(
                    environmentConfigurations.environment_id,
                    'extra_menus'
                );
                extra_menus = brandExtraMenus || null;
            }

            if (extra_menus) {
                EnvironmentStorage.setConfigurations({
                    ...environmentConfigurations,
                    extra_menus,
                });
            }
        } else {
            extra_menus = environmentConfigurations.extra_menus;
        }

        return extra_menus;
    }
}